export default __webpack_public_path__ + "static/media/ao.36c4fa3d.svg";